import type { Auth0ProviderOptions } from '@auth0/auth0-react';
import type { Auth0ClientOptions } from '@auth0/auth0-spa-js';

export const auth0Config: Auth0ClientOptions | Auth0ProviderOptions = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN!,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
  authorizationParams: {
    audience: process.env.REACT_APP_AUTH0_AUDIENCE!,
    redirect_uri: window.location.origin,
  },
};
